namespace GeniuzPOS.Inventory {
    export interface IcStockTranForm {
    }

    export class IcStockTranForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockTran';
    }
}
